import React from "react";
import { useIntl } from "react-intl";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import theme from "../../../theme";
import Tooltip from "@material-ui/core/Tooltip";
import { GetTranslation } from "../../../translations/GetTranslation";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

export enum StateIconType {
  Incomplete,
  Completed,
  Error,
  Paid,
  FullyBooked,
}

interface StateIconProps {
  state: StateIconType;
}

const StateIcon: React.FunctionComponent<StateIconProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case StateIconType.Completed:
      return (
        <Tooltip title={GetTranslation(intl, "icon.state.completed")}>
          <CheckCircleOutlineIcon htmlColor={theme.palette.primary.main} />
        </Tooltip>
      );
    case StateIconType.Error:
      return (
        <Tooltip title={GetTranslation(intl, "icon.state.error")}>
          <ErrorOutlineIcon color="error" />
        </Tooltip>
      );
    case StateIconType.Paid:
      return (
        <Tooltip title={GetTranslation(intl, "icon.state.paid")}>
          <CheckCircleOutlineIcon htmlColor={theme.palette.success.main} />
        </Tooltip>
      );
    case StateIconType.FullyBooked:
      return (
        <Tooltip title={GetTranslation(intl, "icon.state.fullyBooked")}>
          <ErrorOutlineIcon color="error" />
        </Tooltip>
      );
    case StateIconType.Incomplete:
    default:
      return (
        <Tooltip title={GetTranslation(intl, "icon.state.incomplete")}>
          <ErrorOutlineIcon color="secondary" />
        </Tooltip>
      );
  }
};

export default StateIcon;
